import { Trans, useTranslation } from 'react-i18next';

import CustomButton from '../../../../../../shared/components/Buttons/CustomButton/CustomButton';
import { CustomModal } from '../../../../../../shared/components/Modals/CustomModal/CustomModal';
import { TRANSLATIONS_PROSPECTS } from '../../../../../../shared/translations/prospects';
import './UnacceptQuoteModal.scss';

export interface IUnacceptQuoteModalProps {
  open: boolean;
  quoteName: string;
  companyName: string;
  onCancel: () => void;
  onConfirm: () => void;
}

const UnacceptQuoteModal = ({ open, quoteName, companyName, onCancel, onConfirm }: IUnacceptQuoteModalProps) => {
  const { t } = useTranslation();
  const { title, bodyWarning, bodyConsequence, cancel, confirm } =
    TRANSLATIONS_PROSPECTS.detail.quotationCard.unacceptQuoteModal;

  return (
    <CustomModal open={open} title={t(title)} onClose={onCancel} size="m">
      <div className="unaccept-quote-modal__body">
        <p className="unaccept-quote-modal__text">
          <Trans i18nKey={bodyWarning} values={{ quoteName }} components={{ b: <b /> }} />
        </p>
        <p className="unaccept-quote-modal__text">
          <Trans i18nKey={bodyConsequence} values={{ companyName }} components={{ b: <b /> }} />
        </p>
      </div>
      <div className="unaccept-quote-modal__footer">
        <CustomButton variant="default" size="m" onClick={onCancel}>
          {t(cancel)}
        </CustomButton>
        <CustomButton variant="lost" size="m" onClick={onConfirm}>
          {t(confirm)}
        </CustomButton>
      </div>
    </CustomModal>
  );
};

export default UnacceptQuoteModal;
